import classNames from 'classnames';
import getHref, {
  urlType as urlTypeProps
} from '../../../helpers/getHref';
import Icon, { IconProps } from '../../Atoms/Icon';
import Text from '../../Atoms/Text';
import Title from '../../Atoms/Title';

interface Props {
  title: string;
  description: string;
  text: string;
  url: string;
  urlType?: urlTypeProps;
  icon: IconProps;
  className?: string;
  onClick?: () => void;
}

function CardContact({
  title,
  description,
  text,
  url,
  urlType = 'link',
  icon,
  className,
  onClick
}: Props) {
  return (
    <a
      href={getHref(url, urlType)}
      target="_blank"
      rel="noreferrer"
      onClick={onClick}
      className={classNames([
        'flex flex-col items-center justify-center gap-2 rounded-xl bg-sl-gray-light py-5 px-3 transition-all duration-300 hover:bg-opacity-80 md:py-8 lg:py-10',
        className
      ])}
    >
      <Title as="h4" className="mb-2">
        <span className="flex flex-row items-center justify-center gap-4 text-center">
          {icon && (
            <Icon icon={icon} className="text-sl-indigo" />
          )}
          {title}
        </span>
      </Title>
      <Text font="circular" className="text-center">
        <span className="text-sm lg:text-lg">
          {description}
        </span>
      </Text>
      <Text
        font="circular"
        className="text-center text-sl-indigo"
      >
        <b className="text-lg lg:text-2xl">{text}</b>
      </Text>
    </a>
  );
}

export default CardContact;
